import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CoreActions } from '@next/core-lib';
import { LocaleService } from '@next/core-lib/i18n';
import { NotificationActions } from '@next/core-lib/notification';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { map, startWith, finalize, mergeMap, catchError } from 'rxjs/operators';

import { BusinessPartnerBackofficeModuleState } from '../../models/business-partner-backoffice.model';
import { BusinessPartnerBackofficeService } from '../../services/business-partner-backoffice.service';
import * as BusinessPartnerBackofficeActions from '../actions/business-partner-backoffice.actions';

@Injectable()
export class BusinessPartnerBackofficeEffects {
  getBusinessPartners$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(BusinessPartnerBackofficeActions.getBusinessPartners),
      mergeMap(({ keyword, currentPage, currentPageSize, sort }) =>
        this.businessPartnerBackofficeService
          .getBusinessPartners(keyword, currentPage, currentPageSize, sort)
          .pipe(
            map((businessPartners) =>
              BusinessPartnerBackofficeActions.getBusinessPartnersSuccess({
                businessPartners: businessPartners.businessPartners,
                pagination: businessPartners.pagination,
              }),
            ),
            catchError((error: HttpErrorResponse) => {
              if (error.status === 404) {
                return of(
                  NotificationActions.errorSnackbar({
                    message: this.locale.translate('businessPartnerBackoffice_searchNotFound'),
                  }),
                  BusinessPartnerBackofficeActions.businessPartnersNotFound(),
                );
              } else {
                return of(
                  NotificationActions.errorSnackbar({
                    message: this.locale.translate('businessPartnerBackoffice_searchError'),
                  }),
                );
              }
            }),
            startWith(CoreActions.setLoading({ loading: true })),
            finalize(() => {
              BusinessPartnerBackofficeActions.clearBusinessPartnerResult();
              return this.store.dispatch(CoreActions.setLoading({ loading: false }));
            }),
          ),
      ),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly businessPartnerBackofficeService: BusinessPartnerBackofficeService,
    private store: Store<BusinessPartnerBackofficeModuleState>,
    private locale: LocaleService,
  ) {}
}
